// extracted by mini-css-extract-plugin
module.exports = {"header":"referalrule_header__bcDW_","table":"referalrule_table__2PunC"};